module.exports = __webpack_public_path__ + "assets/img/pane1.0e18478d.jpg";